// Wrapper for react-native as env variables are cut off when using CLI

let isTest;
try {
  isTest = global.__TEST__ || process.env.__TEST__;
} catch (e) {
  isTest = false;
}

export default isTest;
